/**
 * This is based heavily on the Material CDK DomPortalOutlet.
 * I just trimmed it down a bunch.
 */
import { EmbeddedViewRef } from '@angular/core';

import { Template } from './Template';

export class DomOutlet {
    private disposeFn: (() => void) | null;
    private template: Template | null;
    private _viewRef: EmbeddedViewRef<any>;

    constructor(public targetElement: Element) {}

    attachTemplate<C>(template: Template): EmbeddedViewRef<C> {
        if (this.template.zone.isStable) {
            this._viewRef = this.template.zone.run(() => {
                return template.viewContainerRef.createEmbeddedView(template.templateRef, template.context);
            });
        } else {
            this._viewRef = template.viewContainerRef.createEmbeddedView(template.templateRef, template.context);
        }

        this._viewRef.rootNodes.forEach(rootNode => this.targetElement.appendChild(rootNode));
        this._viewRef.detectChanges();

        this.setDisposeFn((() => {
            const index = template.viewContainerRef.indexOf(this._viewRef);
            if (index !== -1) {
                template.viewContainerRef.remove(index);
            }
        }));

        return this._viewRef;
    }

    updateContext(context: {[prop: string]: any}): void {
        for (const prop in context) {
            if (context.hasOwnProperty(prop)) {
                this._viewRef.context[prop] = context[prop];
            }
        }

        this._viewRef.detectChanges();
    }

    setDisposeFn(fn: () => void) {
        this.disposeFn = fn;
    }

    attach(template: Template): EmbeddedViewRef<any> {
        this.template = template;
        return this.attachTemplate(template);
    }

    detach(): void {
        if (this.template) {
            this.template.setAttachedHost(null);
            this.template = null;
        }

        this.invokeDisposeFn();
    }

    dispose(removeParent = true): undefined {
        this.disposeFn();
        if (removeParent && this.targetElement.parentNode != null) {
            this.targetElement.parentNode.removeChild(this.targetElement);
        }
        return undefined;
    }

    private invokeDisposeFn() {
        if (this.disposeFn) {
            this.disposeFn();
            this.disposeFn = null;
        }
    }
}


